import { createContext } from 'react'

/**
 * WebSocketコンテキストの定義
 *
 * Provider コンポーネント (WebSocketContext.tsx) と分離しているのは、
 * コンポーネント以外を export すると react-refresh (HMR) が
 * ファイル単位の高速リロードをできなくなるため。
 * フック本体は hooks/useWebSocket.ts にある。
 */

export type MessageListener = (message: Record<string, unknown>) => void
export type ReconnectCallback = () => void

export interface WebSocketContextValue {
  connected: boolean
  sendMessage: (message: unknown) => boolean
  reconnect: () => void
  addListener: (listener: MessageListener) => () => void
  addReconnectCallback: (callback: ReconnectCallback) => () => void
}

export const WebSocketContext = createContext<WebSocketContextValue | null>(null)
